/* eslint no-underscore-dangle: ["error", { "allow": ["_root"] }] */
// need this eslint rule since griddle now produces dangling vars...

import React from 'react';
import PropTypes from 'prop-types';
import Griddle, {
  plugins,
  RowDefinition,
  ColumnDefinition,
} from 'griddle-react';
import _ from 'lodash';
import RaisedButton from 'material-ui/RaisedButton';

import urldecode from '../../../helpers/urldecode';
import ContactCard from '../../../components/ContactCard/ContactCard';

import caseInsensitiveSort from '../../../helpers/caseInsensitiveSort';

import classes from './User.scss';
import { Link } from 'react-router';
import { Dialog, FlatButton } from 'material-ui';
import PeoplePicker from '../../../components/PeoplePicker/PeoplePicker';

const renderAvatarAndName = data => (
  <ContactCard
    id={data.value._root.entries[0][1]}
    name={data.value._root.entries[1][1]}
    avatar={data.value._root.entries[2][1]}
    type="staff"
    displayType="normal"
  />
);

const prepareData = dataArray => {
  const returnData = {
    totalUsers: 0,
    totalStaff: 0,
    deletedStaff: 0,
  };
  const newData = [];
  _.forOwn(dataArray, data => {
    // create new object that will be handled by griddle
    let phone = '';
    if (
      typeof data.meta !== 'undefined' &&
      typeof data.meta.tel !== 'undefined' &&
      typeof data.meta.tel.value !== 'undefined' &&
      data.meta.tel.value !== null
    ) {
      phone = data.meta.tel.value;
    }
    let section = '';
    if (typeof data.meta.section !== 'undefined') {
      section = data.meta.section.value;
    }
    let position = '';
    if (typeof data.meta.position !== 'undefined') {
      position = data.meta.position.value;
    }
    if (typeof data.name !== 'undefined' && data.name.length) {
      newData.push({
        id: data.id,
        person: {
          id: data.id,
          name: data.name,
          avatar: urldecode(data.avatar),
        },
        user: {
          id: data.user_id,
          active: typeof data.user !== 'undefined',
          deleted: data.deleted_at,
        },
        phone,
        email: data.email,
        position,
        section,
        status: data.status,
        button: {
          id: data.user_id,
          active: typeof data.user !== 'undefined',
          email: data.email,
          staffId: data.id,
          deleted: data.deleted_at,
          status: data.status,
        },
      });
      returnData.totalStaff += 1;
      if (data.user_id !== null && data.user_id.length) {
        returnData.totalUsers += 1;
      }
      if (data.deleted_at) {
        returnData.deletedStaff += 1;
      }
    }
  });
  returnData.data = newData;
  return returnData;
};

class User extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      changeAdminVisible: false,
      adminId: null,
    };
  }
  componentDidMount() {
    this.props.fetchStaff();
    this.refresh = setTimeout(() => {
      this.forceUpdate();
    }, 1000);
    this.refreshSlow = setTimeout(() => {
      this.forceUpdate();
    }, 4000);
  }
  componentWillUnmount() {
    clearTimeout(this.refresh);
    clearTimeout(this.refreshSlow);
  }
  checkIfWithinLimits = (resource, action, id) => {
    if (this.props.limits[`${resource}Left`] > 0) {
      // its okay, more than enough left
      // console.log('within limits');
      action(id);
    } else {
      // can't execute, no resources left
      // console.log('not within limits');
      this.props.addFeedback(
        'error',
        `Sie können keine weiteren Benutzer einladen.
      Löschen Sie bestehende oder wechseln Sie auf einen größeren SiMPL Plan`,
      );
    }
  };
  renderButton = data => {
    if (!this.props.login.amIAdmin) {
      return <span>Keine Berechtigung</span>;
    }
    if (
      data.value._root.entries[4][1] !== null &&
      data.value._root.entries[4][1].length
    ) {
      return (
        <RaisedButton
          label="Wiederherstellen"
          onClick={() =>
            this.props.restoreObject(
              encodeURIComponent('App\\Staff'),
              data.value._root.entries[3][1],
            )
          }
        />
      );
    }
    if (
      data.value._root.entries[2][1] !== null &&
      data.value._root.entries[2][1].length
    ) {
      if (
        data.value._root.entries[0][1] !== null &&
        typeof data.value._root.entries[0][1] !== 'undefined'
      ) {
        if (
          data.value._root.entries[5][1] !== null &&
          data.value._root.entries[5][1] === 'Administrator'
        ) {
          return (
            <RaisedButton
              label="Administration abgeben"
              primary
              onClick={() => this.setState({ changeAdminVisible: true })}
              buttonStyle={{
                backgroundColor: 'red',
              }}
            />
          );
        }
        // data.value._root.entries[0][1].length &&
        // data.value._root.entries[1][1]
        return (
          <RaisedButton
            label="Zugriff Entfernen"
            primary
            onClick={() =>
              this.props.removeInvitedStaff(data.value._root.entries[3][1])
            }
            buttonStyle={{
              backgroundColor: 'red',
            }}
          />
        );
      }
      return (
        <RaisedButton
          label="Einladen"
          primary
          onClick={() =>
            this.checkIfWithinLimits(
              'users',
              this.props.inviteStaff,
              data.value._root.entries[3][1],
            )
          }
        />
      );
    }
    return (
      <span>
        Benötigt eine Email Adresse
        <br />
        um eingeladen zu werden.
      </span>
    );
  };
  renderAdminInfo = () => {
    if (!this.props.login.amIAdmin) {
      return (
        <div className={classes.adminWarning}>
          <h3>
            Achtung: Sie sind nicht Administrator dieses SiMPL Unternehmens. Um
            Änderungen vorznunehmen, kontaktieren Sie bitte&nbsp;
            <Link
              className={classes.inlineLink}
              to={`/staff/${this.props.login.admin.id}`}
            >
              &nbsp;{this.props.login.admin.name}
            </Link>
          </h3>
        </div>
      );
    }
    return <div />;
  };
  render() {
    const components = {
      NoResults: () => (
        <div>
          <p className="text-center">
            <small>Keine Benutzer angelegt.</small>
          </p>
        </div>
      ),
    };
    const tableData = prepareData(this.props.staffs);

    const actions = [
      <FlatButton
        label="Abbrechen"
        onMouseDown={() => {
          this.setState({ changeAdminVisible: false });
        }}
      />,
      <FlatButton
        primary
        label="Speichern"
        onMouseDown={() => {
          this.props.switchAdmin(this.state.adminId);
          this.setState({ changeAdminVisible: false });
        }}
      />,
    ];

    const dialogStyle = {
      width: '100%',
      maxWidth: '520px',
    };

    return (
      <div className="wrapper">
        <div>
          <h2 className={`${classes.zenHeader} gutter`}>
            {tableData.totalUsers} Benutzer -&nbsp;
            {tableData.totalStaff} Mitarbeiter ({tableData.deletedStaff}{' '}
            gelöscht) -&nbsp;
            <Link to={'/staff'}>Zur Mitarbeiterverwaltung</Link>
          </h2>

          {this.renderAdminInfo()}

          <Griddle
            data={tableData.data}
            plugins={[plugins.LocalPlugin]}
            pageProperties={{
              pageSize: 5000,
            }}
            components={components}
          >
            <RowDefinition keyColumn="id">
              <ColumnDefinition
                id="id"
                title="ID"
                cssClassName="text-right"
                visible={false}
                sortMethod={caseInsensitiveSort}
              />
              <ColumnDefinition
                id="person"
                title="Name"
                customComponent={renderAvatarAndName}
                sortMethod={caseInsensitiveSort}
              />
              <ColumnDefinition
                id="email"
                title="E-Mail"
                sortMethod={caseInsensitiveSort}
              />
              <ColumnDefinition id="status" title="Status" />
              <ColumnDefinition
                id="button"
                title="Aktion"
                customComponent={this.renderButton}
              />
            </RowDefinition>
          </Griddle>
        </div>

        <Dialog
          title="Administration übergeben"
          actions={actions}
          modal
          autoScrollBodyContent
          open={this.state.changeAdminVisible}
          contentStyle={dialogStyle}
          // onRequestClose={() => props.setTask(null)}
          className="form modal-center"
          contentClassName="form-container form-container--admin"
        >
          <div className={classes.adminChangeForm}>
            <label>
              An welchen Benutzer wollen Sie die Administration übergeben?
            </label>
            <PeoplePicker
              name="assignee"
              type="users"
              clearable={false}
              value={this.state.adminId}
              default={this.props.login.admin.id}
              onChange={e => this.setState({ adminId: e.target.value })}
            />
            <p>
              <small>
                Diese Aktion kann nur durch den neuen Administrator rückgängig
                gemacht werden.
              </small>
            </p>
          </div>
          <div className="firefoxSpacer" />
        </Dialog>
      </div>
    );
  }
}
User.propTypes = {
  fetchStaff: PropTypes.func.isRequired,
  inviteStaff: PropTypes.func.isRequired,
  switchAdmin: PropTypes.func.isRequired,
  removeInvitedStaff: PropTypes.func.isRequired,
  restoreObject: PropTypes.func.isRequired,
  addFeedback: PropTypes.func.isRequired,
  staffs: PropTypes.object.isRequired,
  login: PropTypes.object.isRequired,
  limits: PropTypes.object.isRequired,
};
export default User;



// WEBPACK FOOTER //
// ./src/routes/User/components/User.js